import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AuthService } from './auth.service';
import { DEFAULT_OL_NAMES, IOlNamesConfig } from '../models/custom-names.model';

@Injectable()
export class OlNamesService {
  constructor(
    private firestore: AngularFirestore,
    private authService: AuthService
  ) {}

  async getOlNames(): Promise<IOlNamesConfig> {
    const defaultConfig = {
      variable_wage_1: DEFAULT_OL_NAMES.VARIABLE_WAGE_1,
      variable_wage_2: DEFAULT_OL_NAMES.VARIABLE_WAGE_2,
      grupo_salarial: DEFAULT_OL_NAMES.GRUPO_SALARIAL,
    };

    try {
      const settings = await this.firestore
        .doc(`empresaMae/${this.authService.dominioId}/ol_config/feature_flags`)
        .get()
        .toPromise();
      if (!settings.exists) {
        return defaultConfig;
      }

      const savedNames = settings?.data()?.['ol_names'];
      return savedNames ? { ...defaultConfig, ...savedNames } : defaultConfig;
    } catch (err) {
      console.log('dependent config err ---', err);
      return defaultConfig;
    }
  }
}
